import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Message = _resolveComponent("Message")
  const _component_SchedulerDocumentParameterForm = _resolveComponent("SchedulerDocumentParameterForm")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.schedulerDocumentParameterDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.documentParameter')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.setParameters
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.set')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            class: "kn-progress-bar",
            mode: "indeterminate"
          }))
        : _createCommentVNode("", true),
      (_ctx.deletedParams.length > 0)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "p-m-2",
            severity: "warn",
            closable: false,
            style: _ctx.schedulerDocumentParameterDialogDescriptor.styles.message
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.deletedParamsMessage), 1)
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parameters, (parameter, index) => {
        return (_openBlock(), _createBlock(_component_SchedulerDocumentParameterForm, {
          key: index,
          class: "p-m-3",
          propParameter: parameter,
          roles: _ctx.roles,
          formulas: _ctx.formulas,
          documentLabel: _ctx.documentLabel,
          onLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLoading($event)))
        }, null, 8, ["propParameter", "roles", "formulas", "documentLabel"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}